import { DownloadError } from './downloadError';
import { DOWNLOAD_MESSAGES } from './downloadMessages';
import { assertBrowserDownloadSupport } from './browserDownloadSupport';

const DOWNLOAD_LINK_REVOKE_DELAY_MS = 250;

export function triggerBrowserDownload(blob: Blob, filename: string): void {
  assertBrowserDownloadSupport();

  if (!blob || blob.size === 0) {
    throw new DownloadError(DOWNLOAD_MESSAGES.DOWNLOAD_FAILED);
  }

  let objectUrl: string | null = null;
  let link: HTMLAnchorElement | null = null;

  try {
    objectUrl = URL.createObjectURL(blob);
    link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    link.rel = 'noopener';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    throw new DownloadError(DOWNLOAD_MESSAGES.BROWSER_UNSUPPORTED, error);
  } finally {
    if (link?.parentNode) {
      link.parentNode.removeChild(link);
    }

    if (objectUrl) {
      window.setTimeout(() => {
        URL.revokeObjectURL(objectUrl);
      }, DOWNLOAD_LINK_REVOKE_DELAY_MS);
    }
  }
}
